module.exports = __webpack_public_path__ + "static/media/instagram.bdfc5210.svg";